import { useState } from "react";
import { useSelector } from "react-redux";
import editIcon from "../../../../images/icons/edit.svg";
import trashIcon from "../../../../images/icons/delete.svg";
import DeleteModal from "../../../common/DeleteModal";
import { Translate } from "../../../Enums/Tranlate";
import DiscountService from "../../../../services/DiscountService";

const CardItem = ({ item, index, setAddModal, setItem, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const discountService = new DiscountService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item.name}</td>
			<td className="text-wrap-mode">{item.code || "-"}</td>
			<td className="text-wrap-mode">{item?.price}</td>
			<td className="text-wrap-mode">{Translate[lang][item?.type]}</td>
			<td className="text-wrap-mode">{item?.vender[`name_${lang}`]}</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{isExist("update_reviews") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{isExist("delete_reviews") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={discountService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
